import React from 'react';
import LoadImage from '../../common/images/LoadImage';

const ShareImage = ({ url, alt }) => {
  return (
    <LoadImage url={url}>
      {({ isLoading }) => {
        if (isLoading) {
          return (
            <div className="loader">
              <img className="hidden" src={url} />
            </div>
          );
        }
        return <img src={url} alt={alt} className="save-send__vehicle-image" />;
      }}
    </LoadImage>
  );
};

export default ShareImage;
